/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useLocation } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { PAYMENT_ROUTE } from "../../constants/routes";
import { colors } from "../../constants/colors";
import { useHasPermission } from "../../hooks/useHasPermission";

/* Components */
import UCButton from "../../components/buttons";
import {useUserContext} from "../../contexts/userContext";

/* Styles */
import styles from "./styles.js";


const PaymentPageHeader = ({addPayment}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const paymentsTab = location.pathname.includes(PAYMENT_ROUTE);
  const { checkPermission } = useHasPermission();

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;


  return (
    <div className={classes.pageHeader}>
      <Container className={classes.container}>
        <Row>
          <Col xs={12} sm={paymentsTab ? 8 : 12} className="gx-0">
            <h1 className={classes.title}>
              {
                paymentsTab ?
                  <FormattedMessage id="payment.title" />
                :
                  <FormattedMessage id="travelcredits.title" />
              }
            </h1>
            <h3 className={classes.subtitle}>
              {
                paymentsTab ?
                  <FormattedMessage id={`payment.subtitle.${providerCode}`} />
                :
                  <FormattedMessage id="travelcredits.subtitle" />
              }
            </h3>
          </Col>
          <Col xs={12} sm={4} className={classes.btnWrapper}>
            {
              paymentsTab && checkPermission("F_CREATE_PAYMENT") &&
              <UCButton
                type="primary"
                className={classes.addBtn}
                onClick={() => addPayment("addPaymentSpinner")}
                text={<FormattedMessage id={`payment.addBtn.${providerCode}`}/>}
                spinner={{
                  name: "addPaymentSpinner",
                  size: 20,
                  color: colors.white,
                }}
              />
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentPageHeader;
